module.exports = __webpack_public_path__ + "staticPO/img/header.16473f2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/header.png
// module id = nvbl
// module chunks = 1